/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingserviceMelcoDigitizingModelsOrderAttachment,
    DigitizingserviceMelcoDigitizingModelsOrderAttachmentFromJSON,
    DigitizingserviceMelcoDigitizingModelsOrderAttachmentFromJSONTyped,
    DigitizingserviceMelcoDigitizingModelsOrderAttachmentToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsOrderAssetsReplace
 */
export interface DigitizingserviceMelcoDigitizingModelsOrderAssetsReplace {
    /**
     * 
     * @type {Array<DigitizingserviceMelcoDigitizingModelsOrderAttachment>}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderAssetsReplace
     */
    attachments?: Array<DigitizingserviceMelcoDigitizingModelsOrderAttachment> | null;
}

export function DigitizingserviceMelcoDigitizingModelsOrderAssetsReplaceFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsOrderAssetsReplace {
    return DigitizingserviceMelcoDigitizingModelsOrderAssetsReplaceFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsOrderAssetsReplaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsOrderAssetsReplace {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(DigitizingserviceMelcoDigitizingModelsOrderAttachmentFromJSON)),
    };
}

export function DigitizingserviceMelcoDigitizingModelsOrderAssetsReplaceToJSON(value?: DigitizingserviceMelcoDigitizingModelsOrderAssetsReplace | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(DigitizingserviceMelcoDigitizingModelsOrderAttachmentToJSON)),
    };
}


